import { AuthOptions } from '@aws-amplify/auth/lib/types';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// const redirectUri = (location.hostname === 'localhost' || location.hostname === '127.0.0.1')
//   ? 'http://localhost:4200'
//   : 'https://dawg3ael7wwug.cloudfront.net';

// const oauth = {
//   domain: 'ashrust-app-dev.s3.ap-southeast-2.amazonaws.com',
//   scope : ['email'],
//   redirectSignIn: redirectUri,
//   redirectSignOut: redirectUri,
//   responseType: 'code',
// } as OAuthOpts;


export const environment = {
  production: false,
  apiEndpoint:
    'https://nmiw1rd8u4.execute-api.ap-southeast-2.amazonaws.com/dev',
  amplify : {
    Auth: {
      identityPoolId: 'ap-southeast-2:a46d1d54-8809-4b5c-ace8-8de5c88b96cf',
      region: 'ap-southeast-2',
      identityPoolRegion: 'ap-southeast-2',
      userPoolId: 'ap-southeast-2_6jiHzRFi1',
      userPoolWebClientId: '3825dabe76668aift1o3b8tctm',
      // oauth,
    } as AuthOptions,
  },
};
